import React, {Component} from 'react';
import _ from 'lodash'
import ReactPaginate from 'react-paginate';
import config from  '../../config';
export default class PaginationBox extends Component {

    constructor(props, context) {
        super(props, context);

        this.state = {
            currentPage: !_.isUndefined(this.props.currentPage) ? this.props.currentPage : 0,
        };
    };

    resetPagination() {
        this.setState({currentPage: 0});
    }

    handlePageClick(currentPage) {
       var queryParams = {'page': currentPage.selected + 1}
        this.props.search(queryParams, true);
        this.setState({currentPage: currentPage.selected});
    }


    render() {

        var perPage = _.isUndefined(this.props.perPage) ?this.props.total :  this.props.perPage

         var pageCount = this.props.total / perPage;
         var showingNumber = (this.state.currentPage * perPage) + ( this.props.total ? 1 : 0);
        if (showingNumber > this.props.total) {
            showingNumber = this.props.total;
        }
         return (
            <div>
                {_.isUndefined(this.props.doNotDisplayPageDataBlock) && this.props.total > 0    ?
                    <div data-testid='total-records-box' className={'pull-left total-records-box no-print ' + (this.props.customTotalBoxClass ? this.props.customTotalBoxClass : '')}  >

                        <span> {showingNumber} to {(this.state.currentPage + 1) * perPage < this.props.total ? (this.state.currentPage + 1) * perPage : this.props.total} of </span><span className="purple">{this.props.total}</span><span> entries</span>
                    </div> : ''
                }
                {pageCount > 1 &&
                <div className={'pagination-box no-print'}    data-testid='pagination-box'>
                    <ReactPaginate
                        breakLabel={<a>...</a>}
                        breakClassName={"break-me"}
                        forcePage={this.state.currentPage}
                        pageCount={pageCount}
                        marginPagesDisplayed={1}
                        pageRangeDisplayed={2}
                        onPageChange={this.handlePageClick.bind(this)}
                        containerClassName={"pagination"}
                        subContainerClassName={"pages pagination"}
                        activeClassName={"active"}/>
                </div>
                }
              <div className="clearfix"></div>
            </div>
        );
    }
}


